/* eslint-disable filenames/match-exported */
export const migrations = {};
export default migrations;